module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Cooking/Dish-7ae697eb0b2834f220c7a04f577f0f31.svg";